__turbopack_context__.v({
  "acknowledgement": "BrP5Uq_acknowledgement",
  "acknowledgementText": "BrP5Uq_acknowledgementText",
  "column": "BrP5Uq_column",
  "columnContent": "BrP5Uq_columnContent",
  "columnItems": "BrP5Uq_columnItems",
  "columnSubtitle": "BrP5Uq_columnSubtitle",
  "columnTitle": "BrP5Uq_columnTitle",
  "contact": "BrP5Uq_contact",
  "container": "BrP5Uq_container",
  "disclaimerColumn": "BrP5Uq_disclaimerColumn",
  "disclaimerText": "BrP5Uq_disclaimerText",
  "disclaimerTitle": "BrP5Uq_disclaimerTitle",
  "flagStrip": "BrP5Uq_flagStrip",
  "flagStripContainer": "BrP5Uq_flagStripContainer",
  "footer": "BrP5Uq_footer",
  "link": "BrP5Uq_link",
  "linkGroupLink": "BrP5Uq_linkGroupLink",
  "logo": "BrP5Uq_logo",
  "navItems": "BrP5Uq_navItems",
  "navLink": "BrP5Uq_navLink",
  "newsletter": "BrP5Uq_newsletter",
  "newsletterButton": "BrP5Uq_newsletterButton",
  "newsletterButtonText": "BrP5Uq_newsletterButtonText",
  "newsletterContainer": "BrP5Uq_newsletterContainer",
  "newsletterIcon": "BrP5Uq_newsletterIcon",
  "newsletterIconWrapper": "BrP5Uq_newsletterIconWrapper",
  "newsletterTitle": "BrP5Uq_newsletterTitle",
  "partner": "BrP5Uq_partner",
  "partners": "BrP5Uq_partners",
  "partnersContainer": "BrP5Uq_partnersContainer",
  "sitemapLink": "BrP5Uq_sitemapLink",
  "sitemapWrapper": "BrP5Uq_sitemapWrapper",
  "socials": "BrP5Uq_socials",
  "socialsContent": "BrP5Uq_socialsContent",
  "socialsWrapper": "BrP5Uq_socialsWrapper",
  "wrapper": "BrP5Uq_wrapper",
});
